var map = {
	"./appointments/appointments.module": [
		"./src/app/main/apps/appointments/appointments.module.ts",
		"appointments-appointments-module"
	],
	"./healthunits/healthunits.module": [
		"./src/app/main/apps/healthunits/healthunits.module.ts",
		"healthunits-healthunits-module"
	],
	"./main/apps/apps.module": [
		"./src/app/main/apps/apps.module.ts",
		"main-apps-apps-module"
	],
	"./main/pages/authentication/login/login.module": [
		"./src/app/main/pages/authentication/login/login.module.ts"
	],
	"./main/pages/home/home.module": [
		"./src/app/main/pages/home/home.module.ts",
		"main-pages-home-home-module"
	],
	"./main/pages/pages.module": [
		"./src/app/main/pages/pages.module.ts",
		"main-pages-pages-module"
	],
	"./main/ui/ui.module": [
		"./src/app/main/ui/ui.module.ts",
		"main-ui-ui-module"
	],
	"./patients/patients.module": [
		"./src/app/main/apps/patients/patients.module.ts",
		"patients-patients-module"
	],
	"./professionals/professionals.module": [
		"./src/app/main/apps/professionals/professionals.module.ts",
		"professionals-professionals-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;